import React, { Component } from 'react';
import cn from 'classnames';
import isObject from 'lodash/isObject';
import dataroomLandingBaseStyles from '@/dataroom/ui/components/Landing/base.scss';
import styles from './tabList.scss';
import Select from '@/Framework/UI/Molecules/Form/Select/legacy';
import { Tab, TabList as TabListWrp, TabPanel, Tabs } from '@dealroadshow/uikit/core/components/Tabs';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';

interface IProps {
  tabs: { value: string, label: string }[],
  defaultTab: string,
  className: string,
  selectClassName: string,
  renderTabContent?: (item: any) => React.ReactNode,
}

const defaultProps = {
  renderTabContent: () => {
  },
};

class TabList extends Component<IProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: this.props.defaultTab,
    };
  }

  onTabChange = (selected) => {
    this.setState({
      // @ts-ignore
      currentTab: isObject(selected) ? selected.value : selected,
    });
  };

  render() {
    return (
      <div className={ cardStyles.cardContainer }>
        <div className={ dataroomLandingBaseStyles.mdContainer }>
          <div className={ this.props.selectClassName }>
            <Select
              name="tabs"
              searchable={ false }
              options={ this.props.tabs }
              value={ this.state.currentTab }
              onChange={ this.onTabChange }
              dataTest="tabListSelect"
            />
          </div>
        </div>
        <Tabs
          defaultTab={ this.state.currentTab }
          dataTest="landingSectionsTabListTabs"
          onChange={ this.onTabChange }
        >
          <TabListWrp className={ cn(styles.tabs, this.props.className) }>
            { this.props.tabs.map((tab) => (
              <Tab
                key={ tab.value }
                tabFor={ tab.value }
                className={ styles.tab }
                activeClassName={ styles.isTabActive }
              >
                <span>{ tab.label }</span>
              </Tab>
            )) }
          </TabListWrp>
          { this.props.tabs.map((item) => (
            <TabPanel tabId={ item.value } key={ item.value }>
              { this.props.renderTabContent(item) }
            </TabPanel>
          )) }
        </Tabs>
      </div>
    );
  }
}

// @ts-ignore
TabList.defaultProps = defaultProps;

export default TabList;
